import { TableCell as NovaBaseTableCell, TableCellProps as NovaTableCellProps } from '@fme-nova/components'
import { default as MuiTableCellBase, TableCellProps as MuiTableCellProps } from '@mui/material/TableCell'

import { createComponentWrapperWithRef, styled, uiTokens } from '../../theme'
import { COLORS } from '../../theme/colors'
import { TableMode } from './TableMode'

export type TableCellProps = (MuiTableCellProps | NovaTableCellProps) & { styleMode?: TableMode }

const MuiTableCell = styled(MuiTableCellBase, {
  shouldForwardProp: (prop) => prop !== 'styleMode',
})<MuiTableCellProps & { styleMode?: TableMode }>`
  border-bottom: 1px solid ${COLORS.divider};
  padding: 16px 8px;

  &:first-of-type {
    padding-left: ${({ styleMode }) => (styleMode === 'Compact' ? '8px' : '16px')};
  }

  p {
    margin: 0;
  }

  & .MuiGrid-root.MuiGrid-container > .MuiGrid-root {
    width: 100%;
  }
`
const NovaTableCell = styled(NovaBaseTableCell, {
  shouldForwardProp: (prop) => prop !== 'styleMode',
})<NovaTableCellProps & { styleMode?: TableMode }>`
  && {
    padding: 0 ${uiTokens.spacing.padding.medium}px;
  }

  &.MuiTableCell-head {
    color: ${uiTokens.uiContent.neutral};
  }

  &.MuiTableCell-body {
    color: ${uiTokens.uiContent.emphasized};
  }

  p {
    margin: ${uiTokens.spacing.padding.small}px 0;
  }

  & .MuiGrid-root.MuiGrid-container > .MuiGrid-root {
    width: 100%;
  }
`

export const TableCell = createComponentWrapperWithRef<TableCellProps>(
  {
    mui: MuiTableCell,
    nova: NovaTableCell,
  },
  'TableCell',
)
